<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/CWl3QN/tc-custom/9781497637504.jpg?1733038151773" alt="This image is the cover for the book Economic Dependency Trap"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Economic Dependency Trap
      </h1>
      <p class="bookDescription body article font2">
        <b>2012 gold medal winner in the self-help category of the prestigious Ippy Awards</b><br/> <br/>This book offers effective strategies to help erase poverty. It advocates self-reliance, policy reform, and cultural awareness. Accountability is required from all: the middle class, the trust fund babies, and the underprivileged who see themselves as perpetual victims and have fallen into the entitlement trap. True blue prints are offered to rescue people from an economical slump and help them improve their lives, and re-obtain a sense of self-worth.<br/>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Calvin Helin
      </h2>
      
      <p class="authorDescription body article">Calvin Helin is a bestselling author, international speaker, entrepreneur, lawyer, and activist for self-reliance. The son of a hereditary chief, Helin grew up in an impoverished, remote Native American village. Written to help eradicate the sort of poverty he faced as a child, Helin&rsquo;s first book,&#160;<I>Dances with Dependency: Out of Poverty through Self-Reliance</I>, is a seven-time bestseller. His second book,&#160;<I>The Economic Dependency Trap: Breaking Free to Self-Reliance</I>, is a multi-award winner. A leading authority on fiscal independence, Helin has been widely featured in the print and broadcast media addressing rising poverty, unemployment rates, and empowerment issues. Helin has received numerous distinctions as an entrepreneur, social activist, and community leader.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Premier Digital Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?16d415f9